import { useFormContext } from "react-hook-form";
import { Tooltip } from "antd";

const SingleLineLongField = ({
  label,
  top,
  htmlfor,
  register,
  required,
  readOnly,
}) => {
  const form = useFormContext();
  register = register || form.register;
  if (!register) {
    throw new Error("No form content and no register passed");
  }

  const htmlFor = htmlfor ? htmlfor : label;
  return (
    <div
      className={`sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start ${
        top ? "" : "sm:border-t"
      } sm:border-gray-200 sm:pt-5 sm:pb-2`}
    >
      {required ? (
        <Tooltip title="Required field">
          <label
            data-tip="React-tooltip"
            htmlFor={`${htmlFor}`}
            className="flex text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
          >
            {label}<span className="text-red-500 ml-1">*</span>
          </label>
        </Tooltip>
      ) : (
        <label
          data-tip="React-tooltip"
          htmlFor={`${htmlFor}`}
          className="flex text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
        >
          {label}
        </label>
      )}
      <div className="mt-1 sm:mt-0 sm:col-span-2">
        <input
          id={`${label}`}
          name={`${htmlFor}`}
          type="text"
          className="block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
          readOnly={readOnly}
          {...register(htmlFor, { required: required })}
        />
      </div>
    </div>
  );
};

export default SingleLineLongField;
